
import Vue from "vue";

export default Vue.extend({
  name: "PaymentSuccess",

  data: () => ({
    timer: null as any,
    usmfLogo: require("@/assets/images/usmf-logo.png"),
  }),

  mounted() {
    this.timer = setTimeout(() => {
      this.toMain();
    }, 30000);
  },

  methods: {
    async toMain() {
      clearTimeout(this.timer);
      await this.$store.dispatch("authentication/logout");
      await this.$router.push("/auth/login");
    },
  },
});
